export default {
  currentModule: (state) => (moduleId) =>
    state.modules.find((module) => moduleId === module.id || moduleId === module.name),
  modules: (state) => state.modules,
};
